<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>Genel Bilgi</span>
        </template>
        <b-card>
          <blog-category />
          <title-text />
          <summary-text />
          <content-text />
          <blog-active-card />
        </b-card>
        <image-card />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Seo Bilgileri
        </template>
        <seo-component data-store="blog/dataItem" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard, BTab, BTabs,
} from 'bootstrap-vue'

import BlogCategory from '@/views/Admin/Blog/elements/BlogCategory.vue'
import TitleText from '@/views/Admin/Blog/elements/Title.vue'
import SummaryText from '@/views/Admin/Blog/elements/Summary.vue'
import ContentText from '@/views/Admin/Blog/elements/Content.vue'
import ImageCard from '@/views/Admin/Blog/elements/Image.vue'
import SeoComponent from '@/layouts/components/common/SeoComponent.vue'
import BlogActiveCard from '@/views/Admin/Blog/elements/ActiveCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BlogActiveCard,
    SeoComponent,
    BTab,
    BTabs,
    BCard,
    BlogCategory,
    TitleText,
    SummaryText,
    ContentText,
    ImageCard,
  },
  computed: {
    itemData() {
      return this.$store.getters['blog/dataItem']
    },
  },
}
</script>
